import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';
import {
  Match2Reward,
  isRandomReward,
  isTimedReward,
} from 'src/replicant/match2/rewards/match2-rewards.ruleset';
import { getMatch2RewardValue } from '../rewards/match2-rewards.utils';
import { getGoalsPath } from '../game/util/assets';
import { matchTheme } from 'src/game/theme/match2/Match2Theme';
import {
  Match2BoosterType,
  Match2PowerupType,
} from 'src/replicant/match2/match2.ruleset';

type Match2ShopBundlesIconType =
  | 'bPoints'
  | 'gems'
  | 'energy'
  | Match2PowerupType
  | Match2BoosterType;

export class Match2ShopBundlesIcon extends View {
  public readonly icon: ImageScaleView;
  public readonly value: LangBitmapFontTextView;
  public readonly infinite: ImageScaleView;

  constructor(opts: ViewOpts) {
    super({
      ...opts,
    });

    this.icon = new ImageScaleView({
      superview: this,
      width: 55,
      height: 55,
      scaleMethod: 'contain',
      centerOnOrigin: true,
      centerAnchor: true,
    });

    this.value = new LangBitmapFontTextView({
      superview: this,
      align: 'center',
      verticalAlign: 'center',
      size: 22,
      font: 'Title',
      width: 60,
      height: 50,
      y: 20,
      centerOnOrigin: true,
      centerAnchor: true,
    });

    this.infinite = new ImageScaleView({
      superview: this,
      width: 28,
      height: 28,
      image: `assets/ui/match2/shopbundles/shopbundles_infinite.png`,
      centerOnOrigin: true,
      centerAnchor: true,
      scaleMethod: 'contain',
      y: 43,
    });
  }

  public setup(reward: Match2Reward) {
    const goalsPath = getGoalsPath();
    const iconMap: Record<Match2ShopBundlesIconType, string> = {
      // Currencies
      bPoints: 'assets/ui/shared/icons/coin.png',
      gems: 'assets/ui/shared/icons/gem.png',
      energy: 'assets/ui/shared/icons/energy.png',

      // Powerups
      bomb: `${goalsPath}icon.bomb.png`,
      rocket: `${goalsPath}icon.rocket.horizontal.png`,
      cube: `${goalsPath}icon.cube.all.png`,

      // Boosters
      dart: matchTheme().getUIAsset('booster_dart.png'),
      bullet: matchTheme().getUIAsset('booster_bullet.png'),
      drill: matchTheme().getUIAsset('booster_drill.png'),
      roulette: matchTheme().getUIAsset('booster_roulette.png'),
    };

    let image;

    if (!isRandomReward(reward)) {
      switch (reward.type) {
        case 'bPoints':
        case 'gems':
        case 'energy':
          image = iconMap[reward.type];
          image = iconMap[reward.type];
          break;
        case 'boosters':
        case 'powerups':
          image = iconMap[reward.subType];
          break;
      }
    }

    if (image) this.icon.updateOpts({ image });

    this.value.localeText = () =>
      `${!isTimedReward(reward) ? 'x' : ''}${getMatch2RewardValue(reward)}`;

    if (isTimedReward(reward)) this.infinite.show();
    else this.infinite.hide();
  }
}
